module.exports = __webpack_public_path__ + "img/IMG_20190127_174023.9c908236.jpg";